import PoolRanking from "../PoolRanking/PoolRanking";
import PoolHeader from "../../../../uikit/PoolHeader/PoolHeader";

import { classNames } from "../../../../utils";
import { PoolStanding } from "../../../../api/types";

interface PoolRankingGridProps {
  pools?: PoolStanding[];
}

const PoolRankingGrid = ({ pools }: PoolRankingGridProps) => {
  const renderPool = (pool: PoolStanding) => {
    if (!pool) {
      return null;
    }

    return (
      <div key={pool.pool_id} className="group relative">
        <PoolHeader>{pool.pool_name}</PoolHeader>
        <PoolRanking pool={pool} />
      </div>
    );
  };
  return (
    <div
      className={classNames(
        "grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-2 xl:gap-x-2",
        !pools
          ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:gap-x-2"
          : ""
      )}
    >
      {pools?.map(renderPool)}
    </div>
  );
};

export default PoolRankingGrid;
